import { render, staticRenderFns } from "./pieEchartFour.vue?vue&type=template&id=86059132&scoped=true"
import script from "./pieEchartFour.vue?vue&type=script&lang=js"
export * from "./pieEchartFour.vue?vue&type=script&lang=js"
import style0 from "./pieEchartFour.vue?vue&type=style&index=0&id=86059132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86059132",
  null
  
)

export default component.exports